import React from 'react';
import { TrackingService } from '../../utils/trackingService';
import {
  FooterWrapper,
  FooterContainer,
  FooterMain,
  NewsletterSection,
  NewsletterContent,
  NewsletterTitle,
  NewsletterDescription,
  NewsletterForm,
  EmailInputWrapper,
  EmailInput,
  SubmitButton,
  PrivacyNotice,
  PrivacyLink,
  FooterDivider,
  FooterBottom,
  FooterBottomContent,
  FooterNav,
  FooterNavLink,
  BrandSection,
  Logo,
  SocialLinks,
  SocialLink,
  SocialIcon,
  HiddenInput,
  HiddenDiv
} from './styles';

const Footer: React.FC = () => {
  return (
    <FooterWrapper>
      <FooterContainer>
        <FooterMain>
          {/* Newsletter Section */}
          <NewsletterSection>
            <NewsletterContent>
              <NewsletterTitle>
                Sign up to receive latest product news, exclusive content and more!
              </NewsletterTitle>
              <NewsletterDescription>
                Stay updated with our latest features and announcements.
              </NewsletterDescription>
            </NewsletterContent>
            
            <NewsletterForm 
              action="https://app.us21.list-manage.com/subscribe/post?u=a301bbf496dc4ebc0ad8a71ef&amp;id=4e2e1980f3&amp;f_id=002ccde1f0" 
              method="post" 
              target="_blank"
              noValidate
              id="mc-embedded-subscribe-form"
              name="mc-embedded-subscribe-form"
              className="validate"
            >
              <EmailInputWrapper>
                <EmailInput 
                  type="email" 
                  name="EMAIL" 
                  required 
                  placeholder="Enter your email address" 
                  aria-label="Email address for newsletter signup"
                  inputMode="email"
                  autoComplete="email"
                  id="mce-EMAIL"
                  className="required email"
                />
                <SubmitButton 
                  type="submit" 
                  name="subscribe"
                  aria-label="Subscribe to newsletter"
                  id="mc-embedded-subscribe"
                  value="Subscribe"
                  onClick={() => TrackingService.track('newsletter_subscribe_button_clicked')}
                >
                  Subscribe
                </SubmitButton>
              </EmailInputWrapper>
              
              <HiddenDiv>
                <input type="hidden" name="tags" value="233545" />
              </HiddenDiv>
              <HiddenInput 
                type="text" 
                name="b_a301bbf496dc4ebc0ad8a71ef_4e2e1980f3" 
                tabIndex={-1} 
                value="" 
                aria-hidden="true"
              />
              
              {/* Mailchimp response containers */}
              <div id="mce-responses" style={{ display: 'none' }}>
                <div className="response" id="mce-error-response" style={{ display: 'none' }}></div>
                <div className="response" id="mce-success-response" style={{ display: 'none' }}></div>
              </div>
              
              <PrivacyNotice>
                By subscribing, you agree to our{' '}
                <PrivacyLink href="/privacy-policy">
                  Privacy Policy
                </PrivacyLink>{' '}
                and consent to receive updates from Niyyah.
              </PrivacyNotice>
            </NewsletterForm>
          </NewsletterSection>
          
          {/* Mailchimp validation script */}
          <script type="text/javascript" src="//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js"></script>
          <script type="text/javascript" dangerouslySetInnerHTML={{
            __html: `(function($) {window.fnames = new Array(); window.ftypes = new Array();fnames[0]='EMAIL';ftypes[0]='email';fnames[1]='FNAME';ftypes[1]='text';fnames[2]='LNAME';ftypes[2]='text';fnames[3]='ADDRESS';ftypes[3]='address';fnames[4]='PHONE';ftypes[4]='phone';fnames[6]='MMERGE6';ftypes[6]='text';fnames[7]='SIGNUPDATE';ftypes[7]='date';fnames[5]='MMERGE5';ftypes[5]='text';}(jQuery));var $mcj = jQuery.noConflict(true);`
          }} />
        </FooterMain>
        
        <FooterDivider />
        
        {/* Footer Bottom */}
        <FooterBottom>
          <FooterBottomContent>
            <BrandSection>
              <Logo src="/niyyah-icon.png" alt="Niyyah" loading="lazy" decoding="async" />
            </BrandSection>
            
            <FooterNav role="navigation" aria-label="Footer navigation">
              <FooterNavLink 
                href="/donation/donate"
                onClick={() => TrackingService.track('footer_donate_clicked')}
              >
                Donate
              </FooterNavLink>
              <FooterNavLink 
                href="mailto:connect@niyyah.app"
                onClick={() => TrackingService.track('footer_contact_us_clicked')}
              >
                Contact Us
              </FooterNavLink>
              <FooterNavLink 
                href="/privacy-policy"
                onClick={() => TrackingService.track('footer_privacy_policy_clicked')}
              >
                Privacy Policy
              </FooterNavLink>
            </FooterNav>
            
            <SocialLinks role="navigation" aria-label="Social media links">
              <SocialLink 
                href="https://www.tiktok.com/@theniyyahapp" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="Follow us on TikTok"
                title="TikTok"
                onClick={() => TrackingService.track('footer_tiktok_clicked')}
              >
                <SocialIcon viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M19 7.5a6.9 6.9 0 0 1-3.8-1.2v6.1a5.4 5.4 0 1 1-5.4-5.4c.3 0 .7 0 1 .1v3a2.4 2.4 0 1 0 1.6 2.3V2h3a6.9 6.9 0 0 0 3.6 5.4Z"/>
                </SocialIcon>
              </SocialLink>
              <SocialLink 
                href="https://www.instagram.com/niyyahapp/" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="Follow us on Instagram"
                title="Instagram"
                onClick={() => TrackingService.track('footer_instagram_clicked')}
              >
                <SocialIcon viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </SocialIcon>
              </SocialLink>
              <SocialLink 
                href="https://www.linkedin.com/company/niyyahapp" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="Connect with us on LinkedIn"
                title="LinkedIn"
                onClick={() => TrackingService.track('footer_linkedin_clicked')}
              >
                <SocialIcon viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M4.98 3.5A2.5 2.5 0 1 1 5 8.5a2.5 2.5 0 0 1 0-5ZM3 9h4v12H3V9Zm7 0h3.8v1.7h.1A4.1 4.1 0 0 1 18.7 9c3 0 5.3 2 5.3 6.4V21h-4v-5.1c0-1.9-.7-3.2-2.3-3.2-1.3 0-2 .9-2.4 1.8V21h-4V9Z"/>
                </SocialIcon>
              </SocialLink>
            </SocialLinks>
          </FooterBottomContent>
        </FooterBottom>
      </FooterContainer>
    </FooterWrapper>
  );
};

export { Footer };